import { UseMutateFunction } from 'react-query';
import { AxiosError } from 'axios';
import { PresignedUrlResponse } from '../models/PresignedUrl';
import { GenericErrorResponse } from '../api-refactored/typings';
import { PutUploadFileToS3Request } from '../api-refactored/s3-upload/usePutUploadFileToS3';

export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) {
    return '0 Bytes';
  }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  // eslint-disable-next-line no-restricted-properties
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const convertMB2Byte = (fileSize: number) => fileSize * 1048576;

/**
 * Methods to upload the files to the target pre-signed url.
 *
 * @param res response that contain the pre-signed url to be uploaded with target file
 * @param uploadedFiles target file to be upload
 * @param uploadMutateFn mutate method to upload the file to s3
 */
export const uploadFile = (
  res: PresignedUrlResponse,
  uploadedFiles: File[],
  uploadMutateFn: UseMutateFunction<
    void,
    AxiosError<GenericErrorResponse>,
    PutUploadFileToS3Request
  >
) => {
  const s3FormData = new FormData();
  s3FormData.append(res.key, uploadedFiles[0], res.key);
  const uploadedFile = import.meta.env.PROD ? uploadedFiles[0] : s3FormData;
  uploadMutateFn({ data: uploadedFile, putUrl: res.presignedUrl });
};

export const acceptableProfilePhotoExtension = '.jpg,.png,.jpeg';
